module.exports = __webpack_public_path__ + "assets/fd502c52ebf78a6e8ec117e8a5258f0b.png";